import React from 'react';

import { Flex, Menu, MenuButton, MenuGroup, MenuItem, MenuList, Tag } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { createPortal } from 'react-dom';

import { Check, ChevronDown } from 'assets/assetsV1/iconComponents';

import { GOAL_IN_PROGRESS_OPTIONS, GOAL_CLOSED_OPTIONS } from 'constants/ProjectConstants';
import { CLOSED_STATUS_COLOR_MAP } from 'constants/ProjectConstants';
import { INPROGRESS_STATUS_COLOR_MAP } from 'constants/ProjectConstants';

import InputLabel from 'uiToolkitV1/InputLabel';
import { GenericControl, ReadOnlyGenericControl } from 'uiToolkitV1/SelectV2/GenericControl';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const StatusTag = (props) => (
  <Tag {...props} borderRadius="4px" boxShadow=" 0px 0px 1px 0px rgba(0, 0, 0, 0.25)" padding="2px 4px" />
);

const options = [
  {
    label: 'In Progress',
    options: GOAL_IN_PROGRESS_OPTIONS,
  },
  {
    label: 'Closure',
    options: GOAL_CLOSED_OPTIONS,
  },
];

export const getSelectedOption = ({ goalClosureStatus, goalProgressLevel }) => {
  if (goalProgressLevel === 'CLOSED') return GOAL_CLOSED_OPTIONS.find(({ value }) => value === goalClosureStatus);

  return GOAL_IN_PROGRESS_OPTIONS.find(({ value }) => value === goalProgressLevel);
};

const MenuListUI = ({ handleOnChange, selectedOption }) => (
  <StyledMenuList h="200px" overflowY="scroll" p="0" zIndex={2}>
    {options.map(({ options, label }) => (
      <StyledMenuGroup key={label} title={label}>
        {options.map(({ value, label, progressLevel }) => {
          const isSelected = value === selectedOption?.value;
          const COLOR_MAP = progressLevel === 'CLOSED' ? CLOSED_STATUS_COLOR_MAP : INPROGRESS_STATUS_COLOR_MAP;

          return (
            <ItemContainer key={value}>
              <StyledMenuItem
                value={value}
                onClick={() => {
                  handleOnChange({
                    goalProgressLevel: progressLevel,
                    goalClosureStatus: progressLevel === 'CLOSED' ? value : null,
                  });
                }}
                $isSelected={isSelected}
              >
                <Flex justifyContent="space-between" alignItems="center" width="100%">
                  <StatusTag bg={COLOR_MAP[value]?.tagColor}>
                    <TextBodyMedium color={COLOR_MAP[value]?.textColor}>{label}</TextBodyMedium>
                  </StatusTag>
                  {isSelected && <Check ml="auto" color="button.blue.focus" />}
                </Flex>
              </StyledMenuItem>
            </ItemContainer>
          );
        })}
      </StyledMenuGroup>
    ))}
  </StyledMenuList>
);

export const GoalStatusComponent = ({
  goalClosureStatus,
  goalProgressLevel,
  onChange,
  isReadOnly,
  isShortLabel = false,
  isPortalRequired = false,
}) => {
  const selectedOption = getSelectedOption({ goalClosureStatus, goalProgressLevel });
  const selectedOptionColors =
    selectedOption?.progressLevel === 'CLOSED'
      ? CLOSED_STATUS_COLOR_MAP[selectedOption?.value]
      : INPROGRESS_STATUS_COLOR_MAP[selectedOption?.value];

  const handleOnChange = ({
    goalClosureStatus: updateGoalClosureStatus,
    goalProgressLevel: updateGoalProgressLevel,
  }) => {
    if (updateGoalClosureStatus !== goalClosureStatus || goalProgressLevel !== updateGoalProgressLevel) {
      onChange({
        goalClosureStatus: updateGoalClosureStatus,
        goalProgressLevel: updateGoalProgressLevel,
      });
    }
  };

  return (
    <Menu autoSelect={false} placement="bottom-end">
      <MenuButton
        sx={{
          p: {
            margin: '0',
          },
          svg: {
            transition: 'transform 150ms ease-in-out',
            width: '24px',
            height: '24px',
          },
          span: { height: '24px' },
          '&[aria-expanded="true"]': {
            svg: {
              transform: 'rotate(180deg)',
            },
          },
        }}
        as={isReadOnly ? ReadOnlyGenericControl : GenericControl}
        EndIcon={ChevronDown}
      >
        <StatusTag bg={selectedOptionColors?.tagColor}>
          <TextBodyMedium color={selectedOptionColors?.textColor}>
            {isShortLabel && selectedOption.shortLabel ? selectedOption.shortLabel : selectedOption?.label}
          </TextBodyMedium>
        </StatusTag>
      </MenuButton>
      {isPortalRequired ? (
        createPortal(<MenuListUI handleOnChange={handleOnChange} selectedOption={selectedOption} />, document.body)
      ) : (
        <MenuListUI handleOnChange={handleOnChange} selectedOption={selectedOption} />
      )}
    </Menu>
  );
};

const OKRStatus = ({ goalClosureStatus, goalProgressLevel, onChange, isReadOnly = false }) => (
  <InputLabel labelText="Status">
    <GoalStatusComponent
      goalClosureStatus={goalClosureStatus}
      goalProgressLevel={goalProgressLevel}
      onChange={onChange}
      isReadOnly={isReadOnly}
    />
  </InputLabel>
);

const ItemContainer = styled.div`
  padding: 2px 8px;
  background: ${(props) => (props.withBackground ? '#fafafa' : 'inherit')};
`;

const StyledMenuGroup = styled(MenuGroup)`
  color: #666666;
  width: 100%;

  margin: 0px;
  margin-top: 2px;

  padding: 8px;
  padding-left: 16px;
  padding-bottom: 4px;
`;

const StyledMenuItem = styled(MenuItem)`
  padding: 8px;

  border-radius: 4px;

  &:hover {
    background: #e6f1fd;
  }
  background: ${({ $isSelected }) => $isSelected && '#e6f1fd'};
`;

const StyledMenuList = styled(MenuList)`
  & > div:first-child {
    padding-top: 8px;
  }

  & > div > div:last-child {
    padding-bottom: 8px;
  }
`;
export default OKRStatus;
